import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
import { ToneStatus } from './tonestatus';

export interface EnglishToneRowCSSStyle extends UIComponentCSSStyle
{
    getToneImageDivCSSStyle(isRowEnabled: boolean):object;
    getToneImageCSSStyle():object;
    getToneDetailsDivCSSStyle(isRowEnabled: boolean):object;
    getToneNameCSSStyle():object;
    getArtistNameDivCSSStyle():object;
    getActionDivCSSStyle():object;
    getLikeCSSStyle(): object;
    getBuyNowCSSStyle(): object;
    getSettingDivCSSStyle():object;
    getDeleteDivCSSStyle(isDeleteEnabled: boolean): object;
    getPlayDivCSSStyle():object;
    getMyAccountDropDownSSStyle(): object; 
    getStatusDivCSSStyle(): object;
    getStatusIconCSSSytle(): object;
    getStatusTextCSSStyle(status: ToneStatus): object;
}

export class EnglishToneRowCSSStyleImpl extends UIComponentCSSStyleImpl implements EnglishToneRowCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            borderRadius:'8px',
            height:'80px',
            marginTop:'20px',
            flexFlow: "row wrap",
            display:'flex',
            flexDirection:'row',
            backgroundColor:this.getResources().getColor(Colors.color_5),
            boxShadow: "0 2px 10px 0 rgba(0,0,0,0.07)"
        };
    }
    
    getToneImageDivCSSStyle(isRowEnabled: boolean):object
    {
        return{
            // width:'80px',
            flex:'0.1',
            height:'80px',
            borderRadius:'8px 0px 0px 8px',
            textAlign: "left",
            cursor: isRowEnabled ? 'pointer' :  "not-allowed",
        };
    }
    
    getToneImageCSSStyle():object
    {
        return{
            // width:'80px',
            flex:'0.1',
            height:'80px',
            borderRadius:'8px 0px 0px 8px'
        };
    }

    getToneDetailsDivCSSStyle(isRowEnabled: boolean):object
    {
        return{
            // width:'350px',
            // minWidth:'90px',
            minWidth: "45px",
            height:'50px',
            textAlign: "left",
            cursor: isRowEnabled ? 'pointer' :  "not-allowed",
            // flex:'0.3',
            flex: 0.5
           
        };
    }
    getToneNameCSSStyle():object
    {
        return{
            // width:'250px',
            flex:'0.5',
            minWidth:'45px',
            margin:'15px 0px 0px 12px',
            fontFamily:  this.getResources().getFontFamily(),
            letterSpacing:'0',
            height:'30px',
            lineHeight:'30px',
            overflow: 'hidden',
            textOverflow: 'ellipsis', 
            fontSize:this.getResources().getFont(Fonts.h8)
        };
    }
    
    getArtistNameDivCSSStyle():object
    {
        return{
            // width:'250px',
            minWidth:'45px',
            flex:"0.5",
            height:'20px',
            margin:'0px 0px 0px 12px',
            fontFamily: this.getResources().getFontFamily(),
            color:this.getResources().getColor(Colors.color_7), 
            letterSpacing:'0',
            lineHeight:'20px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize:this.getResources().getFont(Fonts.h7)
        };
    }

    getBuyNowCSSStyle(): object {
      return {
        flex:'0.1',
        height:'100%',
        marginLeft:'auto',
        // borderRight:'0.5px solid '+this.getResources().getColor(Colors.color_3),
        padding:'28px 17px',
        cursor:'pointer'
      };
    }

    getLikeCSSStyle(): object 
    {
        return{
            // width:'79px',
            height:'100%',
            flex:'0.003',
            // marginLeft:'auto',
            borderLeft:'1px solid '+this.getResources().getColor(Colors.color_3),
            // borderRight:'1px solid '+this.getResources().getColor(Colors.color_3),
            padding:'28px 17px',
            cursor:'pointer',
            // display:"flex",
        };
    }  

    getActionDivCSSStyle():object
    {
        return{
            // width:'79px',
            // display:"flex",
            flex:'0.003',
            height:'100%',
            borderLeft:'1px solid '+this.getResources().getColor(Colors.color_3),
            // borderRight:'0.5px solid '+this.getResources().getColor(Colors.color_3),
            padding:'28px 17px',
            cursor:'pointer'
        };
    }
    getSettingDivCSSStyle():object
    {
        return{
            // width:'79px',
            height:'100%',
            flex:'0.003',
            
            borderLeft:'1px solid '+this.getResources().getColor(Colors.color_3),
            // borderRight:'1px solid '+this.getResources().getColor(Colors.color_3),
            padding:'28px 17px',
            cursor:'pointer',
            // display:"flex",
        };
    }

    getDeleteDivCSSStyle(isDeleteEnabled: boolean): object {
        return{
            // width:'79px',
            height:'100%',
            flex:'0.003',
            borderLeft:'1px solid '+this.getResources().getColor(Colors.color_3),
            // borderRight:'1px solid '+this.getResources().getColor(Colors.color_3),
            padding:'28px 17px',
            cursor: isDeleteEnabled ? 'pointer' :  "not-allowed",
            // display:"flex",
        };
    } 
    getPlayDivCSSStyle():object
    {
        return{
            // width:'79px',
            flex:'0.003',
            height:'100%',
            borderLeft:'1px solid '+this.getResources().getColor(Colors.color_3),
            // border:'none',
            padding:'28px 16px',
            cursor:'pointer',
            // display:"flex",
        };
    }
    
    getMyAccountDropDownSSStyle(): object 
    {
        return {
            display: "flex",
            width: "140px",
            marginTop: "15px",
            position: "absolute",
            zIndex: 2,
            right: "0px",
            borderRadius:'0px 0px 8px 8px',
            border: '1px solid #EAECEF',
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }

    getStatusDivCSSStyle(): object 
    {
        return{
            // width:'79px',
            height:'100%',
            flex:'0.003',
            marginLeft:'auto',
            borderLeft:'1px solid '+this.getResources().getColor(Colors.color_3),
            // borderRight:'1px solid '+this.getResources().getColor(Colors.color_3),
            paddingLeft:'17px',
            paddingTop: "17px",
            paddingBottom: "17px",
            paddingRight:'17px',
            textAlign: "center",
            // cursor:'pointer',
            // display:"flex",
        };
    }

    getStatusIconCSSSytle(): object 
    {
        throw new Error("Method not implemented.");
    }

    getStatusTextCSSStyle(status: ToneStatus): object {
       return{
        height: "20px",
        color: this.getStatusColor(status),
        fontFamily: this.getResources().getFontFamily(),
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "20px",
       };
    }

    getStatusColor(status: ToneStatus): string
    {
        if(status === ToneStatus.REJECTED)
        {
            return "#E21736";
        }
        else if(status === ToneStatus.PENDING)
        {
            return  "#FF8F18";
        }
        else
        {
           return "#404042";
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/englishtonerowcss.tsx